export const getSelectOptions = () => [
	{ value: 'all', label: 'All' },
	{ value: 'active', label: 'Active' },
	{ value: 'new', label: 'New' },
	{ value: 'completed', label: 'Completed' },
];
